export default function (x) {
  return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
}
